<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มการอนุญาต</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{
                timeAttendanceOffSiteGrantInit.employee
                  ? timeAttendanceOffSiteGrantInit.employee.employee_code
                  : ''
              }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{
                timeAttendanceOffSiteGrantInit.employee
                  ? `${timeAttendanceOffSiteGrantInit.employee.firstname_th} ${timeAttendanceOffSiteGrantInit.employee.lastname_th}`
                  : ''
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <v-dialog v-model="dialogEmployeeList" scrollable width="420px">
              <template v-slot:activator="{ on, attrs }">
                <label class="body-2">
                  พนักงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  :value="timeAttendanceOffSiteGrant.employeeSelected.text"
                  :rules="[(v) => !!v || 'โปรดระบุพนักงาน']"
                  :append-icon="formAction === 'add' ? 'mdi-plus' : ''"
                  @click:append="dialogEmployeeList = true"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  :disabled="formAction === 'edit'"
                >
                </v-text-field>
              </template>
              <v-card>
                <v-card-title class="pt-0 px-4">
                  <v-text-field
                    v-model="searchEmployees"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    placeholder="รหัส - ชื่อพนักงาน"
                    hide-details
                    @input="handleSearchEmployees"
                    :loading="loadingEmployees"
                  ></v-text-field>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px" class="pa-0">
                  <v-list>
                    <v-list-item-group>
                      <v-list-item
                        v-for="employee in employees"
                        :key="employee.employee_uuid"
                        @click="handleEmployeeSelected(employee)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ employee.employee_code }} -
                            {{ employee.firstname_th }}
                            {{ employee.lastname_th }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <p v-if="employees.length === 0" class="mt-5 text-center">
                        {{
                          loadingEmployees ? 'กำลังโหลดข้อมูล' : 'ไม่มีข้อมูล'
                        }}
                      </p>
                    </v-list-item-group>
                    <v-list-item-group
                      v-if="
                        employees.length > 0 &&
                        employees.length < totalEmployees
                      "
                      v-intersect="onIntersect"
                    ></v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              ref="dialogDateStart"
              v-model="modalDateStart"
              :return-value.sync="timeAttendanceOffSiteGrant.date_start"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="body-2"> วันเริ่มต้น </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="2"
                    :value="timeAttendanceOffSiteGrantDateStartFormatted"
                    :rules="[ruleDateStart || 'จำเป็นต้องใส่วันที่']"
                    append-icon="mdi-calendar"
                    @click:append="modalDateStart = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="timeAttendanceOffSiteGrantClear('date_start')"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </template>
              <v-date-picker
                v-model="timeAttendanceOffSiteGrant.date_start"
                scrollable
                locale="th-TH"
                :year-format="yearFormatted"
                :header-date-format="headerDateFormatted"
                :max="timeAttendanceOffSiteGrant.date_end"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalDateStart = false"
                  >ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialogDateStart.save(
                      timeAttendanceOffSiteGrant.date_start
                    )
                  "
                  >ตกลง
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="dialogTimeStart"
              v-model="modalTimeStart"
              :return-value.sync="timeAttendanceOffSiteGrant.time_start"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="body-2"> เวลาเริ่มต้น </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="3"
                    :value="timeAttendanceOffSiteGrant.time_start"
                    :rules="[ruleTimeStart || 'จำเป็นต้องใส่เวลา']"
                    append-icon="mdi-clock-outline"
                    @click:append="modalTimeStart = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="timeAttendanceOffSiteGrantClear('time_start')"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </template>
              <v-time-picker
                v-if="modalTimeStart"
                v-model="timeAttendanceOffSiteGrant.time_start"
                full-width
                format="24hr"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalTimeStart = false"
                  >ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialogTimeStart.save(
                      timeAttendanceOffSiteGrant.time_start
                    )
                  "
                  >ตกลง
                </v-btn>
              </v-time-picker>
            </v-dialog>
            <v-dialog
              ref="dialogDateEnd"
              v-model="modalDateEnd"
              :return-value.sync="timeAttendanceOffSiteGrant.date_end"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="body-2"> วันสิ้นสุด </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="4"
                    :value="timeAttendanceOffSiteGrantDateEndFormatted"
                    :rules="[ruleDateEnd || 'จำเป็นต้องใส่วันที่']"
                    append-icon="mdi-calendar"
                    @click:append="modalDateEnd = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="timeAttendanceOffSiteGrantClear('date_end')"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </template>
              <v-date-picker
                v-model="timeAttendanceOffSiteGrant.date_end"
                scrollable
                locale="th-TH"
                :year-format="yearFormatted"
                :header-date-format="headerDateFormatted"
                :min="timeAttendanceOffSiteGrant.date_start"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalDateEnd = false"
                  >ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialogDateEnd.save(
                      timeAttendanceOffSiteGrant.date_end
                    )
                  "
                  >ตกลง
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-dialog
              ref="dialogTimeEnd"
              v-model="modalTimeEnd"
              :return-value.sync="timeAttendanceOffSiteGrant.time_end"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <label class="body-2"> เวลาสิ้นสุด </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="5"
                    :value="timeAttendanceOffSiteGrant.time_end"
                    :rules="[ruleTimeEnd || 'จำเป็นต้องใส่เวลา']"
                    append-icon="mdi-clock-outline"
                    @click:append="modalTimeEnd = true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="timeAttendanceOffSiteGrantClear('time_end')"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </template>
              <v-time-picker
                v-if="modalTimeEnd"
                v-model="timeAttendanceOffSiteGrant.time_end"
                full-width
                format="24hr"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalTimeEnd = false"
                  >ยกเลิก
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialogTimeEnd.save(
                      timeAttendanceOffSiteGrant.time_end
                    )
                  "
                  >ตกลง
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </tab>
          <tab
            title="ระบุสถานที่"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div
              v-if="
                formAction === 'add' && !isShowTimeAttendanceOffSiteLocationAdd
              "
            >
              กรุณาเพิ่มข้อมูลทั่วไปก่อน
            </div>
            <div v-else>
              <v-text-field
                v-model="search"
                class="fix-google-chrome"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
              >
              </v-text-field>

              <div class="mt-2 mb-4">
                <button
                  type="button"
                  @click="$emit('onClickAddOffSiteLocation')"
                >
                  <v-icon left small color="primary">mdi-plus</v-icon>
                  <span class="caption primary--text">
                    เพิ่มการระบุสถานที่
                  </span>
                </button>
              </div>

              <RecycleScroller
                :items="filterTimeAttendanceOffSideLocations"
                :item-size="74"
                key-field="offsite_location"
                v-slot="{ item }"
              >
                <v-card
                  color="#f5f5f5"
                  outlined
                  class="d-flex align-center mb-2"
                >
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.offsite_location.title_th }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        รัศมี: {{ item.radius_meter }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <div class="px-2 d-flex">
                    <v-btn icon @click="handleEditLocationMember(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon @click="handleDeleteLocationMember(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </RecycleScroller>
              <div v-if="isLoading">
                <v-card
                  color="#f5f5f5"
                  v-for="num in 2"
                  :key="num"
                  outlined
                  class="mb-2 px-4 py-2"
                >
                  <Skeleton width="200px" />
                  <Skeleton :count="1" />
                </v-card>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row
          justify="center"
          align="center"
          v-if="
            (!isTimeAttendanceOffSiteGrantDataChange &&
              formAction === 'edit') ||
            (formAction === 'add' && isShowTimeAttendanceOffSiteLocationAdd)
          "
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::offsite_grant:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::offsite_grant:create')"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::offsite_grant:update')"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogRadiusMeter" persistent max-width="500">
      <v-form ref="formRadiusMeter" lazy-validation>
        <v-card>
          <v-card-title>
            <span>แก้ไขสถานที่ : {{ locationItem.title }}</span>
          </v-card-title>
          <v-card-text>
            <label class="body-2">
              รัศมี (เมตร)
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              v-model="locationItem.radius_meter"
              :rules="[
                (v) => !!v || 'โปรดระบุรัศมี (เมตร)',
                (v) => /^[0-9]*$/.test(v) || 'รัศมีต้องเป็นตัวเลขจำนวนเต็ม',
              ]"
              clearable
              required
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="handleDialogRadiusMeterCancel"> ยกเลิก </v-btn>
            <v-btn color="primary" text @click="handleDialogRadiusMeterSubmit">
              ตกลง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteMember"
      :loading="confirmDialogDeleteLoadingMember"
      :dialogData="confirmDialogDeleteDataMember"
      @cancelConfirmDialog="cancelConfirmDialogDeleteMember"
      @submitConfirmDialog="submitConfirmDialogDeleteMember"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { Skeleton } from 'vue-loading-skeleton'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'

export default {
  components: {
    ConfirmDialog,
    Tab,
    Tabs,
    RecycleScroller,
    Skeleton,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    timeAttendanceOffSiteGrant: {
      type: Object,
    },
    timeAttendanceOffSiteGrantInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogForbidden: false,
      dialogRadiusMeter: false,
      locationItem: {
        title: '',
        radius_meter: null,
      },
      isLoading: false,
      search: '',
      selectedTab: 0,
      isShowTimeAttendanceOffSiteLocationAdd: false,
      loadingEmployees: false,
      dialogEmployeeList: false,
      searchEmployees: null,
      employees: [],
      loading: false,
      itemsPerPage: 10,
      page: 1,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteMember: false,
      confirmDialogDeleteLoadingMember: false,
      confirmDialogDeleteDataMember: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      modalDateStart: false,
      modalDateEnd: false,
      modalTimeStart: false,
      modalTimeEnd: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    filterTimeAttendanceOffSideLocations() {
      const items = this.timeAttendanceOffSiteGrant.locations || []
      return items.filter((item) =>
        item.offsite_location.title_th
          .toLowerCase()
          .includes(this.search ? this.search.toLowerCase() : '')
      )
    },
    timeAttendanceOffSiteGrantDateStartFormatted() {
      return this.timeAttendanceOffSiteGrant.date_start
        ? moment(this.timeAttendanceOffSiteGrant.date_start).format(
            'DD/MM/YYYY'
          )
        : ''
    },
    timeAttendanceOffSiteGrantDateEndFormatted() {
      return this.timeAttendanceOffSiteGrant.date_end
        ? moment(this.timeAttendanceOffSiteGrant.date_end).format('DD/MM/YYYY')
        : ''
    },
    isTimeAttendanceOffSiteGrantDataChange() {
      if (
        (this.timeAttendanceOffSiteGrant.employeeSelected &&
          this.timeAttendanceOffSiteGrant.employeeSelected.value) !==
          (this.timeAttendanceOffSiteGrantInit.employeeSelected &&
            this.timeAttendanceOffSiteGrantInit.employeeSelected.value) ||
        this.timeAttendanceOffSiteGrant.date_start !==
          this.timeAttendanceOffSiteGrantInit.date_start ||
        this.timeAttendanceOffSiteGrant.time_start !==
          this.timeAttendanceOffSiteGrantInit.time_start ||
        this.timeAttendanceOffSiteGrant.date_end !==
          this.timeAttendanceOffSiteGrantInit.date_end ||
        this.timeAttendanceOffSiteGrant.time_end !==
          this.timeAttendanceOffSiteGrantInit.time_end
      ) {
        this.$emit('isTimeAttendanceOffSiteGrantDataChange', true)
        return true
      }
      this.$emit('isTimeAttendanceOffSiteGrantDataChange', false)
      return false
    },
    ruleDateStart() {
      if (
        this.timeAttendanceOffSiteGrant.time_start &&
        !this.timeAttendanceOffSiteGrant.date_start
      )
        return false
      return true
    },
    ruleTimeStart() {
      if (
        this.timeAttendanceOffSiteGrant.date_start &&
        !this.timeAttendanceOffSiteGrant.time_start
      )
        return false
      return true
    },
    ruleDateEnd() {
      if (
        this.timeAttendanceOffSiteGrant.time_end &&
        !this.timeAttendanceOffSiteGrant.date_end
      )
        return false
      return true
    },
    ruleTimeEnd() {
      if (
        this.timeAttendanceOffSiteGrant.date_end &&
        !this.timeAttendanceOffSiteGrant.time_end
      )
        return false
      return true
    },
    totalEmployees() {
      return this.$store.state.employee.totalEmployees
    },
  },
  async created() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      const fetchEmployees = this.getEmployees({
        company_uuid,
        params: {
          is_active: true,
        },
      })

      const response = await Promise.all([fetchEmployees])

      const employees = response[0]
      this.employees = [...employees]
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetchEmployees',
      addTimeAttendanceOffSiteGrant:
        'timeAttendanceOffSiteGrant/addTimeAttendanceOffSiteGrant',
      editTimeAttendanceOffSiteGrant:
        'timeAttendanceOffSiteGrant/editTimeAttendanceOffSiteGrant',
      deleteTimeAttendanceOffSiteGrant:
        'timeAttendanceOffSiteGrant/deleteTimeAttendanceOffSiteGrant',
    }),
    handleDialogRadiusMeterSubmit() {
      if (this.$refs.formRadiusMeter.validate()) {
        const data = {
          employee_uuid: this.timeAttendanceOffSiteGrant.employeeSelected.value,
          start_time:
            this.timeAttendanceOffSiteGrant.date_start &&
            this.timeAttendanceOffSiteGrant.time_start
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_start} ${this.timeAttendanceOffSiteGrant.time_start}`
                  )
                  .format()
              : null,
          end_time:
            this.timeAttendanceOffSiteGrant.date_end &&
            this.timeAttendanceOffSiteGrant.time_end
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_end} ${this.timeAttendanceOffSiteGrant.time_end}`
                  )
                  .format()
              : null,
          locations: [
            ...this.timeAttendanceOffSiteGrant.locations.map((item) => {
              if (
                item.offsite_location.offsite_location_uuid ===
                this.locationItem.offsite_location_uuid
              ) {
                return {
                  offsite_location_uuid:
                    this.locationItem.offsite_location_uuid,
                  radius_meter: parseInt(this.locationItem.radius_meter),
                }
              } else {
                return {
                  offsite_location_uuid:
                    item.offsite_location.offsite_location_uuid,
                  radius_meter: item.radius_meter,
                }
              }
            }),
          ],
        }

        this.dialogRadiusMeter = false
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          time_attendance_offsite_grant_uuid:
            this.timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid,
          data,
        }

        this.editTimeAttendanceOffSiteGrant(payload)
          .then((timeAttendanceOffSiteGrant) => {
            this.$emit(
              'addTimeAttendanceOffSiteGrantSuccess',
              timeAttendanceOffSiteGrant
            )
            this.$store.state.loading = false
            this.locationItem = {
              offsite_location_uuid: '',
              title: '',
              radius_meter: null,
            }

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
          })
          .catch((error) => {
            this.confirmDialogDeleteLoadingMember = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    handleDialogRadiusMeterCancel() {
      this.dialogRadiusMeter = false
      this.locationItem = {
        offsite_location_uuid: '',
        title: '',
        radius_meter: null,
      }
      this.$refs.formRadiusMeter.resetValidation()
    },
    handleEditLocationMember(item) {
      this.locationItem = {
        offsite_location_uuid: item.offsite_location.offsite_location_uuid,
        title: item.offsite_location.title_th,
        radius_meter: item.radius_meter,
      }
      this.dialogRadiusMeter = true
    },
    handleDeleteLocationMember(item) {
      this.confirmDialogDeleteMember = true
      this.confirmDialogDeleteDataMember = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบสถานที่',
        value: `${item.offsite_location.title_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteMember() {
      this.confirmDialogDeleteMember = false
    },
    submitConfirmDialogDeleteMember({
      offsite_location: { offsite_location_uuid },
    }) {
      this.confirmDialogDeleteLoadingMember = true

      const data = {
        employee_uuid: this.timeAttendanceOffSiteGrant.employeeSelected.value,
        start_time:
          this.timeAttendanceOffSiteGrant.date_start &&
          this.timeAttendanceOffSiteGrant.time_start
            ? moment
                .utc(
                  `${this.timeAttendanceOffSiteGrant.date_start} ${this.timeAttendanceOffSiteGrant.time_start}`
                )
                .format()
            : null,
        end_time:
          this.timeAttendanceOffSiteGrant.date_end &&
          this.timeAttendanceOffSiteGrant.time_end
            ? moment
                .utc(
                  `${this.timeAttendanceOffSiteGrant.date_end} ${this.timeAttendanceOffSiteGrant.time_end}`
                )
                .format()
            : null,
        locations: [
          ...this.timeAttendanceOffSiteGrant.locations
            .filter(
              (item) =>
                item.offsite_location.offsite_location_uuid !==
                offsite_location_uuid
            )
            .map((item) => ({
              offsite_location_uuid:
                item.offsite_location.offsite_location_uuid,
              radius_meter: item.radius_meter,
            })),
        ],
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        time_attendance_offsite_grant_uuid:
          this.timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid,
        data,
      }

      this.editTimeAttendanceOffSiteGrant(payload)
        .then((timeAttendanceOffSiteGrant) => {
          this.$emit(
            'addTimeAttendanceOffSiteGrantSuccess',
            timeAttendanceOffSiteGrant
          )
          this.confirmDialogDeleteLoadingMember = false
          this.confirmDialogDeleteMember = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoadingMember = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleEmployeeSelected(employee) {
      this.timeAttendanceOffSiteGrant.employeeSelected = {
        text: `${employee.employee_code} - ${employee.firstname_th} ${employee.lastname_th}`,
        value: employee.employee_uuid,
      }
      this.dialogEmployeeList = false
    },
    handleSearchEmployees() {
      this.loadingEmployees = true
      this.getEmployeesBySearch()
    },
    getEmployeesBySearch: _.debounce(async function () {
      this.page = 1
      const res = await this.getEmployees()
      this.employees = [...res]
    }, 1000),
    async onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.page = this.page + 1
        const res = await this.getEmployees()
        this.employees = [...this.employees, ...res]
      }
    },
    async getEmployees() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingEmployees = true

        const payload = {
          company_uuid,
          params: {
            dpc: 'time-attendance-off-site-grant-to-list-employee',
            search: this.searchEmployees || undefined,
            is_active: true,
            sort: 'employee_code:asc',
            preset: 'selector',
            limit: this.itemsPerPage,
            offset: (this.page - 1) * this.itemsPerPage,
          },
        }

        const res = await this.fetchEmployees(payload)
        return res
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingEmployees = false
      }
    },
    timeAttendanceOffSiteGrantClear(field) {
      this.timeAttendanceOffSiteGrant[field] = undefined
    },
    yearFormatted(year) {
      return `ค.ศ. ${year}`
    },
    headerDateFormatted(date) {
      // use momentjs
      return moment(date).locale('th').format('MMMM YYYY')

      // not use library
      // const monthsOfYear = [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤศจิกายน',
      //   'ธันวาคม'
      // ]
      // let i = new Date(date).getMonth(date)
      // return `${monthsOfYear[i]} ${date.split('-')[0]}`
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบการอนุญาต',
        value: `${this.timeAttendanceOffSiteGrant.employeeSelected.text}`,
        item: this.timeAttendanceOffSiteGrant,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(timeAttendanceOffSiteGrant) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        time_attendance_offsite_grant_uuid:
          timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid,
      }

      this.deleteTimeAttendanceOffSiteGrant(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const newData = {
          employee_uuid: this.timeAttendanceOffSiteGrant.employeeSelected.value,
          start_time:
            this.timeAttendanceOffSiteGrant.date_start &&
            this.timeAttendanceOffSiteGrant.time_start
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_start} ${this.timeAttendanceOffSiteGrant.time_start}`
                  )
                  .format()
              : null,
          end_time:
            this.timeAttendanceOffSiteGrant.date_end &&
            this.timeAttendanceOffSiteGrant.time_end
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_end} ${this.timeAttendanceOffSiteGrant.time_end}`
                  )
                  .format()
              : null,
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          data: newData,
        }

        this.addTimeAttendanceOffSiteGrant(payload)
          .then((timeAttendanceOffSiteGrant) => {
            this.$emit(
              'addTimeAttendanceOffSiteGrantSuccess',
              timeAttendanceOffSiteGrant
            )
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            this.isShowTimeAttendanceOffSiteLocationAdd = true
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const dataUpdate = {
          employee_uuid: this.timeAttendanceOffSiteGrant.employeeSelected.value,
          start_time:
            this.timeAttendanceOffSiteGrant.date_start &&
            this.timeAttendanceOffSiteGrant.time_start
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_start} ${this.timeAttendanceOffSiteGrant.time_start}`
                  )
                  .format()
              : null,
          end_time:
            this.timeAttendanceOffSiteGrant.date_end &&
            this.timeAttendanceOffSiteGrant.time_end
              ? moment
                  .utc(
                    `${this.timeAttendanceOffSiteGrant.date_end} ${this.timeAttendanceOffSiteGrant.time_end}`
                  )
                  .format()
              : null,
          locations: [
            ...this.timeAttendanceOffSiteGrant.locations.map((item) => ({
              offsite_location_uuid:
                item.offsite_location.offsite_location_uuid,
              radius_meter: item.radius_meter,
            })),
          ],
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          time_attendance_offsite_grant_uuid:
            this.timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid,
          data: dataUpdate,
        }

        this.editTimeAttendanceOffSiteGrant(payload)
          .then((timeAttendanceOffSiteGrant) => {
            this.$emit(
              'addTimeAttendanceOffSiteGrantSuccess',
              timeAttendanceOffSiteGrant
            )
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isTimeAttendanceOffSiteGrantDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
        this.isShowTimeAttendanceOffSiteLocationAdd = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.isShowTimeAttendanceOffSiteLocationAdd = false
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.isShowTimeAttendanceOffSiteLocationAdd = false
    },
  },
}
</script>
